export const getDate4mothsAfter = (weeks = 16) => {
  const weeksToMs = 7 * 24 * 60 * 60 * 1000;
  const weeksCount = weeks * weeksToMs;
  const toDay = new Date();

  const dateAfter4Months = Math.round(Math.abs(toDay) + weeksCount);

  return new Date(dateAfter4Months);
};

//Calcula una fecha despues de 6 años
export const getDateAfter = (weeks = 313) => {
  const weeksToMs = 7 * 24 * 60 * 60 * 1000;
  const weeksCount = weeks * weeksToMs;
  const toDay = new Date();

  const dateAfter = Math.round(Math.abs(toDay) + weeksCount);

  return new Date(dateAfter);
};
export const getDateBefore = (weeks = 313) => {
  const weeksToMs = 7 * 24 * 60 * 60 * 1000;
  const weeksCount = weeks * weeksToMs;
  const toDay = new Date();

  const dateAfter = Math.round(Math.abs(toDay) - weeksCount);

  return new Date(dateAfter);
};

export const calcEndDate = (date, weeks = 0) => {
  const weeksToMs = 7 * 24 * 60 * 60 * 1000;
  const weeksCount = weeks * weeksToMs;
  const dateStart = new Date(date);

  // console.log(Math.abs(dateStart), '<-sirve2')
  const dateEnd = Math.round(Math.abs(dateStart) + weeksCount);

  // const [lastDate] = new Date(dateEnd).toISOString().split("T");
  const lastDate = new Date(dateEnd)
    .toLocaleDateString("en-AU")
    .split("/")
    .reverse()
    .join("-");

  return lastDate;
};

export const getToday = () => {
  // const [toDay] = new Date().toISOString().split("T");
  const toDay = new Date()
    .toLocaleDateString("en-AU")
    .split("/")
    .reverse()
    .join("-");
  return toDay;
};

export const dateConvertor = (date) => { // este no sirve bn
  const dateFormat = new Date(date)
    .toLocaleDateString("en-AU")
    .split("/")
    .reverse()
    .join("-");
  return dateFormat;
};

export const dateFormat = (dateInput) => {
  const date = new Date(dateInput).toLocaleDateString();
  return date;
};
